import { v4 as uuid } from 'uuid';
import type { Project } from '@y2/api-clients/yad1';
import { BlueSentSpotIllustration } from '@y2/mango/components/illustrations/spot';

import texts from './lead-success.texts.json';
import { FeedbackPopupLayout } from '../../../components/popups/feedback-popup-layout/feedback-popup-layout';
import type { FormData } from '../../../pages/gray-project/temp/features/lead-form/lead-form';
import { submitProjectYad1LeadForm } from '../../lead-popup/yad1-lead-form/utils/form-handler';
import { ProjectsInYourArea } from '../../projects-in-your-area/projects-in-your-area';

type Props = {
  className?: string;
  onClose: () => void;
  similarProjects: Project[];
  formData: FormData;
};

export const LeadSuccess = ({
  className,
  onClose,
  similarProjects,
  formData,
}: Props) => {
  const handleProjectClick = async (projectId: string) => {
    await submitProjectYad1LeadForm({
      name: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      projectId,
      site: 'yad1',
      source: 'internal',
      trackingId: uuid(),
      projectType: 'sales',
    });
  };

  const hasSimilarProjects = similarProjects.length > 0;

  return (
    <FeedbackPopupLayout
      className={className}
      onClose={onClose}
      illustration={<BlueSentSpotIllustration />}
      heading={texts.heading}
      message={texts.message}
      bottomSlot={
        hasSimilarProjects && (
          <ProjectsInYourArea
            projects={similarProjects}
            onProjectClick={handleProjectClick}
          />
        )
      }
    />
  );
};
